'use strict';
var angular = require('angular');

var dashboardTaskCtrl = ['Department', '$state', 'Client', 'Member', '$scope', function (Department, $state, Client, Member, $scope) {
    var _this = this;
    this.selectedForm = null;
    this.selectedClient = null;
    this.selectedMembers = [];
    this.datePopup = false;
    this.endDatePopup = false;
    $state.template=undefined;
    this.listfields = [];
    this.membersSelected = [];

    // The getMembersNew function needs to be placed at the beginning for correct execution order.
    // This ensures that it is defined before being invoked elsewhere in the code, preventing any 'undefined' errors during execution.
    // Keep in mind that getMembersNew and getMembers should return the same list of members.
    // Therefore, if any modifications are made in one function, the other function should be reviewed to ensure consistency.
    this.getMembersNew = function (query) {
      // console.log('query', query);
      var scope = {};

      if (query) {
        scope = {
          where: {
            or: [{
              email: {
                regexp: '/^' + query + '/i'
              }
            }, {
              firstName: {
                regexp: '/' + query + '/i'
              }
            }, {
              lastName: {
                regexp: '/' + query + '/i'
              }
            }]
          }
        };
      }

      return Department.teams({
        id: $state.params.departmentId,
        filter: {
          include: {
            relation: 'members',
            scope: scope
          }
        }
      })
        .$promise
        .then(function (teams) {
          // console.log('teams init', teams);
          if (teams) {
            var members = teams.reduce(function (memberList, team) {
              // We add the first team.
              if (!memberList.length) {
                memberList = memberList.concat(team.members);
              }

              // Remaining teams, we check if the member is already on the list
              team.members.forEach(function (member) {
                for (var i = 0; i < memberList.length; i++) {
                  if (member.id === memberList[i].id) {
                    return;
                  }
                }
                // We return the list for next iteration
                memberList.push(member);
              });
              // console.log('memberList', memberList);

              return memberList;

            }, []);
            // console.log('members', members);

            // "We retrieve the status of team members from local storage using _this.membersSelected = JSON.parse(localStorage.getItem('membersCFG')).
            // If the 'members' array has elements, the code iterates through the user statuses stored in localStorage. 
            // For each user with a status of hide === false, it searches for the corresponding member in the 'members' array and adds them to the selectedMembers list."
            _this.membersSelected = JSON.parse(localStorage.getItem('membersCFG'));
            if (members) {
              _this.membersSelected.forEach((memberSelected) => {
                if (memberSelected.hide === false) {
                  members.find((member) => {
                    if (memberSelected.email === member.email) {
                      _this.selectedMembers.push(member);
                    }
                  })
                }
              })
            }

            return members;
          }
          return [];
        })
        .catch(function (error) {
          console.log(error);
        });
    };

    // If the task is not new, we add important data
    if (this.task.id) {
        this.selectedTemplate = this.task.name;
        this.selectedForm = this.task.form || null;
        this.selectedClient = this.task.client || null;
        this.selectedMembers = angular.copy(this.task.member);    
        
        // console.log(this.task.member);
        
        this.listfields = this.selectedForm.pages.flatMap(page=>page.fields.filter(f=>!["docs","title","photo","video","sign","autonumeric","group"].includes(f.type)));

        delete this.task.tenantId;
    } else {
      // "For a new task, the team members' list is loaded, and the list of members is retrieved from local storage.
      // If they are selected (hide === false), they are assigned to selectedMembers to appear pre-selected in the form."
      this.getMembersNew();
    }

    function validateTask(task) {
        //if anything is missing we return
        if (!task.name || !task.formId || !task.startDate || !task.endDate || !task.clientId || _this.selectedMembers.length < 1) {
            return false;
        }

        if ((task.endDate - task.startDate) <= 0) {
            return false;
        }

        //if repeat is selected we validate the options
        if (task.repeat) {
            //type
            if (!task.repeatData.repeatType) {
                return false;
            }
            //for each type
            if (task.repeatData.repeatType === 'daily') {
                if (!task.repeatData.repeatEvery || (task.repeatData.repeatEvery < 1) || task.repeatData.repeatEvery > 365) {
                    return false;
                }
            }
            if (task.repeatData.repeatType === 'weekly') {
                var counter = false;
                for (var day in task.repeatData.repeatWeekDays) {
                    counter = task.repeatData.repeatWeekDays[day] ? task.repeatData.repeatWeekDays[day] : counter;
                }
                if (!counter) {
                    return false;
                }
            }

            if (task.repeatData.repeatEnds) {
                if (!(task.repeatData.repeatTill instanceof Date)) {
                    return false;
                }
            }
        }
        return true;
    }

    this.dateOptions = {
        minDate: new Date(),
        showWeeks: false
    };

    this.endDateOptions = {
        minDate: new Date(),
        showWeeks: false
    };

    this.updateEndDates = function () {
        _this.endDateOptions.minDate = _this.task.date;
    };

    this.updateEndDate = function () {
        var hours = _this.task.endDate.getHours();
        var minutes = _this.task.endDate.getMinutes();
        var endDate = new Date(_this.task.startDate);
        endDate.setHours(hours);
        endDate.setMinutes(minutes);
        _this.task.endDate = endDate;
    };

    this.getForms = function (value) {
        var query = {
            id: $state.params.departmentId
        };

        if (value) {
            query.filter = {
                where: {
                    name: {
                        regexp: '/^' + value + '/i'
                    }
                }
            };
        }
        return Department.forms(query)
            .$promise
            .then(function (forms) {
                return forms;
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    this.getTemplates = function (value) {
        var query = {
            id: $state.params.departmentId,
            filter: { include: 'form' }
        };

        if (value) {
            query.filter.where = {
                name: {
                    regexp: '/^' + value + '/i'
                }
            };
        }

        return Department.tasktemplate(query)
            .$promise
            .then(function (forms) {
                return forms;
            })
            .catch(function (error) {
                console.log(error);
            });
    };


    this.getClients = function (value) {
        var query = {

        };

        if (value) {
            query.filter = {
                where: {
                    name: {
                        regexp: '/^' + value + '/i'
                    }
                }
            };
        }
        return Client.find(query)
            .$promise
            .then(function (clients) {
                return clients;
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    // Keep in mind that getMembersNew and getMembers should return the same list of members.
    // Therefore, if any modifications are made in one function, the other function should be reviewed to ensure consistency.
    this.getMembers = function (query) {
      // console.log('query', query);
        var scope = {};

        if (query) {
            scope = {
                where: {
                    or: [{
                        email: {
                            regexp: '/^' + query + '/i'
                        }
                    }, {
                        firstName: {
                            regexp: '/' + query + '/i'
                        }
                    }, {
                        lastName: {
                            regexp: '/' + query + '/i'
                        }
                    }]
                }
            };
        }

        return Department.teams({
            id: $state.params.departmentId,
            filter: {
                include: {
                    relation: 'members',
                    scope: scope
                }
            }
        })
            .$promise
            .then(function (teams) {
                var members = teams.reduce(function (memberList, team) {
                    //we add the first team, easy peasy.
                    if (!memberList.length) {
                        memberList = memberList.concat(team.members);
                    }

                    //remaining teams, we check if the member is already on the list
                    team.members.forEach(function (member) {
                        for (var i = 0; i < memberList.length; i++) {
                            if (member.id === memberList[i].id) {
                                return;
                            }
                        }
                        //we return the list for next iteration
                        memberList.push(member);
                    });
                    // console.log('memberList', memberList);
                    return memberList;

                }, []);
                // console.log('members', members);
                return members;
            })
            .catch(function (error) {
                console.log(error);
            });
    };

    this.formSelected = function (form) {
        this.task.formId = form.id;
        this.listfields = form.pages.flatMap(page=>page.fields.filter(f=>!["docs","title","photo","video","sign","autonumeric","group"].includes(f.type)));
    };

    this.useTemplate = function (template, model, label) {
        if (!template.id) {
            this.task.name = template;
            return;
        }
        $state.template = template;

        this.task.name = template.name;
        this.task.description = template.description;
        this.task.formId = template.formId;
        this.selectedForm = template.form;
        
        this.listfields = this.selectedForm.pages.flatMap(page=>page.fields.filter(f=>!["docs","title","photo","video","sign","autonumeric","group"].includes(f.type)));
        
        this.task.payload = [];
        if (template.payloadHidden == undefined) {
            template.payloadHidden = {};
        }

        if (_this.task.payloadHidden == undefined) {
            _this.task.payloadHidden = {};
        }

        // The old data type (strings) is converted to the new one (object)
        template.payload = template.payload.map((item) => {
            if (typeof item === 'string') {
                return {
                    key: item,
                    value: null,
                    fieldId: null,
                    id: Math.random().toString(36).substr(2, 9)
                }
            } else {
                return {
                    key: item.key ? item.key : null,
                    value: item.value ? item.value : null,
                    fieldId: item.fieldId || null,
                    id: item.id ? item.id : Math.random().toString(36).substr(2, 9),
                }
            }
        });

        template.payload.forEach(function (field) {
            _this.task.payload.push(field)
            _this.task.payloadHidden[field.key] = template.payloadHidden[field.key] || false;
        });

        // console.log('template.payload', template.payload);
    };

    this.clientSelected = function (client) {
        this.task.clientId = client.id;
    };

    this.clearRepeatData = function () {
        if (!this.task.repeat) {
            for (var prop in this.task.repeatData) {
                this.task.repeatData[prop] = null;
            }
        }
    };

    this.clearRepeatTypeData = function () {
        for (var prop in this.task.repeatData) {
            if (prop !== 'repeatType' && prop !== 'repeatTill' && prop !== 'repeatEnds') {
                this.task.repeatData[prop] = null;
            }
        }
        if (this.task.repeatData.repeatType === 'daily') {
            this.task.repeatData.repeatEvery = 1;
        }
    };

    this.limitRepeatDays = function () {
        if (this.task.repeatData.repeatEvery > 365) {
            this.task.repeatData.repeatEvery = 365;
        }
    };

    this.saveTask = function (task) {
        validateTask(task);
    };

    // Watchers
    $scope.$watch(function () {
        return _this.task;
    }, function () {
        _this.taskValidation = validateTask(_this.task);
    }, true);

    $scope.$watch(function () {
        return _this.selectedTemplate;
    }, function () {
        if (_this.selectedTemplate && !_this.selectedTemplate.id) {
            _this.task.name = _this.selectedTemplate;
        }
        if (!_this.selectedTemplate) {
            _this.task.name = null;
        }
    }, true);

    $scope.$watch(function () {
        return _this.selectedMembers;
    }, function () {
        _this.taskValidation = validateTask(_this.task);
    }, true);

    $scope.$watch(function () {
        return _this.selectedClient;
    }, function () {
        if (!_this.selectedClient) {
            _this.task.clientId = null;
        }
        _this.taskValidation = validateTask(_this.task);
    }, true);

    $scope.$watch(function () {
        return _this.selectedForm;
    }, function () {
        if (!_this.selectedForm) {
            _this.task.formId = null;
        }
        _this.taskValidation = validateTask(_this.task);
    }, true);

}];

module.exports = function () {
    return {
        restrict: 'E',
        scope: {
            task: '=',
            taskValidation: '=',
            selectedMembers: '='
        },
        controller: dashboardTaskCtrl,
        controllerAs: 'ctrl',
        bindToController: true,
        templateUrl: 'dashboard-task/dashboardTaskDirective.html'
    };
};
